module.exports = __webpack_public_path__ + "static/img/ic_high_on@2x.5c47dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_high_on@2x.png
// module id = 6PfX
// module chunks = 1